module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-man-20_14406260d10593a0eb0f35047dc0e9b3.png";